import React from 'react';
import { ReportList } from './ReportList';
import { useReportContext } from './ReportContext';
import { ReportDataLoader } from './ReportDataLoader';

interface ReportsProps {
  className: string;
}

export const Reports = React.memo(({ className }: ReportsProps) => {
  const { selectedJob, selectedReportTemplate } = useReportContext();

  return (
    <>
      {/* Load report data when a job is selected (without navigating away) */}
      {selectedJob && selectedReportTemplate && (
        <ReportDataLoader />
      )}
      <ReportList className={className} />
    </>
  );
});

Reports.displayName = 'Reports';
